import React from 'react';
import { useHistory } from "react-router-dom";


import './Landing.scss';

import { ROUTER_ENDPOINTS } from '../../router/router-endpoints';
import { useAuth } from '../../services/auth/auth-context';

import { Core } from './Core/Core';
import { Tutorial } from './Tutorial/Tutorial';
import { RealPosts } from './RealPosts/RealPosts';
import { SectionTitle } from '../../components/SectionTitle/SectionTitle';
import { ImportantPoints } from './ImportantPoints/ImportantPoints';
import { Button } from '../../components/basic/Button/Button';

export function Landing() {
  const history = useHistory();
  const auth = useAuth();

  const handleAuthClick = () => {
    history.push(ROUTER_ENDPOINTS.AUTH);
  };

  return (
    <div className='Landing'>
      <section className='Landing__section'>
        <Core />
      </section>

      <section className='Landing__section'>
        <SectionTitle title='Remember' />
          <ImportantPoints />
      </section>

      <section className='Landing__section'>
        <Tutorial />
      </section>

      {
        !auth.user
          ? (
            <section className='Landing__section'>
              <div className='Landing__join-button'>
                <h2 className='Landing__subtitle'>Become a member now</h2>
                <Button buttonType='neutral' text='Join' handleClick={handleAuthClick} />
              </div>
            </section>
          )
          : null
      }
      
      <section className='Landing__section'>
        <RealPosts />
      </section>

    </div>
  );
}
